import * as React from "react";
import PropTypes from "prop-types";
const SvgNavigationCalendarNormalSmall = React.forwardRef(
  ({ color = "currentColor", size = 24, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M9 2V1H7v1H4a3 3 0 00-3 3v11.063a3 3 0 001.08 2.305l4.724 3.937a3 3 0 001.92.695H20a3 3 0 003-3V5a3 3 0 00-3-3h-3V1h-2v1zm6 2v2h2V4h3a1 1 0 011 1v2H3V5a1 1 0 011-1h3v2h2V4zM3 15V9h18v11a1 1 0 01-1 1H10v-6zm.562 2H8v3.698z"
        fill=""
      />
    </svg>
  )
);
SvgNavigationCalendarNormalSmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgNavigationCalendarNormalSmall;
